import React from 'react';
import { useTranslation } from 'react-i18next';

import ButtonDropdown from '@/component-library/primitives/ButtonDropdown/ButtonDropdown';
import protectedRoute from '@/utils/routes/PrivateRoute';

const EmailTablePage = () => {
  // Assuming you have an array of data for the table
  const tableData = [
    {
      email: 'example1@example.com',
      status: 'Sent',
      date: '2023-05-28',
      send: true,
      opened: true,
      clicked: false,
    },
    {
      email: 'example2@example.com',
      status: 'Sent',
      date: '2023-05-29',
      send: true,
      opened: false,
      clicked: false,
    },
    // Add more data as needed
  ];
  const { t } = useTranslation();

  const dropdownOptions = [
    { text: t('EmailTablePage.newEmailOption'), href: `/messages/email/new` },
    // Add more options as needed
  ];
  const yesLabel = t('EmailTablePage.yesLabel');
  const noLabel = t('EmailTablePage.noLabel');
  return (
    <div className="min-h-screenWithoutHeader p-4">
      <div className="flex justify-between">
        <h1 className="text-white text-3xl">{t('EmailTablePage.title')}</h1>
        <ButtonDropdown
          options={dropdownOptions}
          buttonText={t('EmailTablePage.dropdownButtonNewMessage')}
          icon={<span>i</span>}
        />
      </div>
      <table className="mt-4 w-full">
        <thead>
          <tr>
            <th className="text-white">{t('EmailTablePage.emailColumn')}</th>
            <th className="text-white">{t('EmailTablePage.statusColumn')}</th>
            <th className="text-white">{t('EmailTablePage.dateColumn')}</th>
            <th className="text-white">{t('EmailTablePage.sendColumn')}</th>
            <th className="text-white">{t('EmailTablePage.openedColumn')}</th>
            <th className="text-white">{t('EmailTablePage.clickedColumn')}</th>
            <th className="text-white">{t('EmailTablePage.actionsColumn')}</th>
          </tr>
        </thead>
        <tbody>
          {tableData.map((data, index) => (
            <tr key={index}>
              <td className="text-white">{data.email}</td>
              <td className="text-white">{data.status}</td>
              <td className="text-white">{data.date}</td>
              <td className="text-white">{data.send ? yesLabel : noLabel}</td>
              <td className="text-white">{data.opened ? yesLabel : noLabel}</td>
              <td className="text-white">{data.clicked ? yesLabel : noLabel}</td>
              <td className="text-white">...</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default protectedRoute(EmailTablePage);
